import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import { P } from './TwoFactorStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorRecoverySuccess = () => {
  const {
    email,
    twoFactorRecoveryType
  } = useContext(TwoFactorRecoveryContext);
  return twoFactorRecoveryType === 'admin' ? /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(P, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.recoveryAdmin.success.emailed"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reAuth.recovery.recoveryAdmin.success.action",
        options: {
          email
        }
      })
    })]
  }) : /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(P, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reAuth.recovery.recoverySupport.success.emailed",
        options: {
          email
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.recoverySupport.success.questions"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.recoverySupport.success.submitted"
      })
    })]
  });
};